import qs from 'qs'
import classNames from 'classnames'
import styles from './index.module.scss'
import { useState } from 'react'
import { pageRoutes } from 'constants/routing'
import { RudderEvent } from 'constants/rudderEvents'
import InsuranceFilter from 'app/SeFriendly/SeFriendlyProviderSearch/InsuranceFilter'
import AreaOfConcernFilter from 'app/SeFriendly/SeFriendlyProviderSearch/AreaOfConcernFilter'
import LocationFilter from 'app/SeFriendly/SeFriendlyProviderSearch/LocationFilter'
import { useRouter } from 'next/router'
import Icon from 'common/Icon'
import logEvent from 'utils/logEvent'

type HeaderFilterProps = {
  groupedFilters: GroupedProviderFilter
}

type Location = {
  location: string
  state: string
  longitude: number
  latitude: number
}

type Insurance = {
  insuranceId?: string
}

type AreaOfConcern = {
  areaOfConcern: []
}

const SeFriendlyHeaderFilter: React.FC<HeaderFilterProps> = ({
  groupedFilters,
}) => {
  const [hideOtherFilters, setHideOtherFilters] = useState<boolean>(false)

  const [location, setLocation] = useState<Location | null>(null)
  const [areaOfConcern, setAreaOfConcern] = useState<AreaOfConcern | null>(null)
  const [insurance, setInsurance] = useState<Insurance | null>(null)
  const [allInsurances, setAllInsurances] = useState<InsuranceProvider[]>([])

  const router = useRouter()

  const createRoute = (filterType) => {
    const parsedPathName = qs.stringify(filterType, {
      encode: false,
      arrayFormat: 'brackets',
      skipNulls: true,
    })
    return parsedPathName
  }

  const handleFilterSearch = () => {
    const parameters = createRoute({
      ...location,
      ...(areaOfConcern && areaOfConcern),
      ...(insurance && insurance),
    })
    router.push(`${pageRoutes.PROVIDER_SEARCH}?${parameters}`)
  }

  const getInsuranceNameFromHash = (insuranceHash) => {
    let insuranceName
    allInsurances.map((insurance) => {
      if (insurance.id === insuranceHash) {
        insuranceName = insurance.name
      }
    })
    return insuranceName
  }

  const getSpecialtiesFromHash = (specialtiesHashArray) => {
    const namedSpecialties = []
    specialtiesHashArray.map((specialty) => {
      groupedFilters['area_of_concern'].map((concern) => {
        if (concern.id === specialty) {
          namedSpecialties.push(concern.value)
        }
      })
    })
    return namedSpecialties
  }

  const onFilterSelect = (selectedFilter) => {
    const rudderStackObject = {
      event_action: 'select ',
      location_city: router.query.city,
      location_state: router.query.state,
    }

    if (router.query.specialty) {
      rudderStackObject['specialty'] = router.query.specialty
    }

    if (location) {
      rudderStackObject['location_selected'] = location
    }

    if (areaOfConcern) {
      rudderStackObject['specialty_selected'] = getSpecialtiesFromHash(
        areaOfConcern.areaOfConcern
      )
    }

    if (insurance) {
      rudderStackObject['insurance_selected'] = getInsuranceNameFromHash(
        insurance.insuranceId
      )
    }

    if (selectedFilter.location) {
      setLocation(selectedFilter)
      rudderStackObject['location_selected'] = selectedFilter.location
      rudderStackObject['event_action'] += ` ${selectedFilter.location}`
    } else if (selectedFilter.areaOfConcern) {
      setAreaOfConcern(selectedFilter)

      const namedSpecialties = getSpecialtiesFromHash(
        selectedFilter.areaOfConcern
      )

      rudderStackObject['specialty_selected'] = namedSpecialties
      rudderStackObject['event_category'] = 'form-search selected speciality'
      const specialtyString = namedSpecialties.join(' ')
      rudderStackObject['event_action'] += specialtyString
    } else if ('insuranceId' in selectedFilter) {
      if (selectedFilter.insuranceId) {
        setInsurance(selectedFilter)

        const namedInsurances = getInsuranceNameFromHash(
          selectedFilter.insuranceId
        )

        rudderStackObject['insurance_selected'] = namedInsurances
        rudderStackObject['event_category'] = 'form-search selected insurance'
        rudderStackObject['event_action'] += `${namedInsurances}`
      } else {
        setInsurance(null)
        delete rudderStackObject['insurance_selected']
      }
    }

    logEvent(RudderEvent.SE_FRIENDLY_SEARCH_OPTION_SELECTED, {
      rudderStackObject,
    })
  }

  return (
    <div
      className={classNames(
        styles.filter_container,
        'flex-fill d-flex align-items-center bg-white bg-light font-gibson'
      )}
    >
      <div
        className={classNames(
          styles.header_filter_container,
          'd-flex align-items-center badge-pill'
        )}
      >
        <LocationFilter
          setHideOtherFilters={setHideOtherFilters}
          onFilterSelect={onFilterSelect}
          containerClassName={classNames(
            styles.location_filter_item,
            'sefriendly-search-bar-location top-page',
            {
              [styles.occupy_full_width]: hideOtherFilters,
            }
          )}
        />

        <div
          className={classNames(
            {
              [styles.other_filters_container]: !hideOtherFilters,
            },
            {
              [styles.hide_filters]: hideOtherFilters,
            }
          )}
        >
          <div className={styles.header_divider} />
          <AreaOfConcernFilter
            onFilterSelect={onFilterSelect}
            groupedFilters={groupedFilters}
            containerClassName={classNames(
              styles.header_filter_items,
              'sefriendly-search-bar-specialty top-page'
            )}
          />
          <div className={styles.header_divider} />
          <InsuranceFilter
            onFilterSelect={onFilterSelect}
            containerClassName={classNames(
              styles.header_filter_items,
              'sefriendly-search-bar-insurance top-page'
            )}
            setAllInsurances={setAllInsurances}
          />
        </div>
        <button className={styles.search_button} onClick={handleFilterSearch}>
          <Icon icon={'search'} fill="white" style={{ zIndex: 1 }} />
        </button>
      </div>
    </div>
  )
}

export default SeFriendlyHeaderFilter
